export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6280.c179f2a4.jpg";